import { usePathname } from 'next/navigation'

const useClinicIsActive = () => {
  const pathname = usePathname()

  const clinicIsActive = pathname.startsWith('/dashboard/clinics')

  return clinicIsActive
}

export default useClinicIsActive
